import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-add-your-product",
  templateUrl: "./add-your-product.component.html",
  styleUrls: ["./add-your-product.component.scss"]
})
export class AddYourProductComponent implements OnInit {
  show;
  constructor(private router: Router) {}

  ngOnInit() {}

  showEvent() {
    this.show = false;
    this.show = true;
  }
  closeEvent() {
    this.show = false;
  }


  redirect() {
    this.router.navigate(['/contactus']);
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/add-your-product/add-your-product.component.ts